<app-navbar />

<div class="container-fluid exportacao-page">
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center justify-content-between rounded-top">
      <div class="d-flex align-items-center">
        <i class="fas fa-file-export fs-5 me-2 text-white"></i>
        <h2 class="fw-bold mb-0">Exportacao</h2>
      </div>
      <span class="badge bg-primary">Total da pesquisa: {{ totalItens }}</span>
    </div>

    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-2">
          <label class="form-label">Exportado</label>
          <select class="form-select" [(ngModel)]="filtroExportado">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Nao</option>
          </select>
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label">Cidade</label>
          <input class="form-control" type="text" [(ngModel)]="filtroCidade" placeholder="Digite a cidade" />
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label">Bairro</label>
          <input class="form-control" type="text" [(ngModel)]="filtroBairro" placeholder="Digite o bairro" />
        </div>

        <div class="col-12 col-md-2">
          <label class="form-label">Numero OS</label>
          <input class="form-control" type="text" [(ngModel)]="filtroNumeroOs" placeholder="00001" />
        </div>

        <div class="col-12 col-md-2 d-flex gap-2">
          <button class="btn btn-gradient-primary w-50" (click)="aplicarFiltros()">
            <i class="bi bi-funnel-fill me-1"></i> Filtrar
          </button>
          <button class="btn btn-warning w-50" (click)="limparFiltros()">
            <i class="bi bi-arrow-clockwise me-1"></i> Limpar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="carregando" class="alert alert-info d-flex align-items-center gap-2">
    <i class="bi bi-hourglass-split"></i> Carregando registros...
  </div>

  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
  </div>

  <div class="table-responsive" *ngIf="!erro">
    <table class="table table-bordered table-hover align-middle mb-0">
      <thead class="table-light">
        <tr>
          <th>Tipo</th>
          <th>Numero OS</th>
          <th>Consumidor</th>
          <th>Documento</th>
          <th>Endereco</th>
          <th>Data Analise</th>
          <th>Exportacao</th>
          <th>Acoes</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="carregando">
          <td colspan="8" class="text-center py-4">Carregando...</td>
        </tr>

        <tr *ngIf="!carregando && registros.length === 0">
          <td colspan="8" class="text-center py-4">Nenhum registro encontrado com os filtros informados.</td>
        </tr>

        <tr *ngFor="let item of registros; let i = index; trackBy: trackByRegistro"
          [ngClass]="{ 'linha-par': i % 2 === 0, 'linha-impar': i % 2 !== 0 }">
          <td>
            <span class="badge tipo-registro-badge"
              [ngClass]="item.tipoRegistro === 'Cadastro' ? 'cadastro-badge' : 'recadastro-badge'">
              {{ item.tipoRegistro }}
            </span>
          </td>
          <td>{{ item.numeroOs || '-' }}</td>
          <td>{{ item.nomeConsumidor || '-' }}</td>
          <td>{{ item.documento || '-' }}</td>
          <td>{{ getEndereco(item) }}</td>
          <td>{{ item.dataHoraInicioAnalise ? (item.dataHoraInicioAnalise | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
          <td>
            <span class="badge exportacao-badge"
              [ngClass]="getClasseStatusExportacao(item)">
              {{ getStatusExportacao(item) }}
            </span>
            <div class="small text-muted" *ngIf="item.exportado && item.dataExportacao">
              {{ item.dataExportacao | date:'dd/MM/yyyy HH:mm' }}
            </div>
            <div class="small text-muted" *ngIf="!item.exportado && item.dataUltimaTentativaExportacao">
              {{ item.dataUltimaTentativaExportacao | date:'dd/MM/yyyy HH:mm' }}
            </div>
          </td>
          <td class="acoes-coluna">
            <div class="acoes-wrapper" *ngIf="podeReenviar(item) || podeDesfazerExportacao(item); else semAcoes">
              <button *ngIf="podeReenviar(item)"
                class="acao-btn acao-reenviar"
                [ngClass]="{ 'acao-reenviar-erro': isErroExportacao(item), 'is-loading': estaReenviando(item) }"
                (click)="reenviarRegistro(item)"
                [disabled]="estaReenviando(item)">
                <i class="fas" [ngClass]="estaReenviando(item) ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                <span>{{ getTextoAcao(item) }}</span>
              </button>

              <button *ngIf="podeDesfazerExportacao(item)"
                class="acao-btn acao-remover"
                [ngClass]="{ 'is-loading': estaDesfazendo(item) }"
                (click)="desfazerExportacaoSucesso(item)"
                [disabled]="estaDesfazendo(item)">
                <i class="fas" [ngClass]="estaDesfazendo(item) ? 'fa-spinner fa-spin' : 'fa-undo'"></i>
                <span>{{ getTextoDesfazer(item) }}</span>
              </button>
            </div>

            <ng-template #semAcoes>
              <span class="text-muted">-</span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between mt-3"
    *ngIf="!erro">
    <div class="page-info small text-muted">
      Pagina {{ paginaAtual }} de {{ totalPaginas || 1 }} ({{ totalItens }} itens)
    </div>

    <div class="d-flex align-items-center gap-2">
      <label class="small mb-0">Itens</label>
      <select class="form-select form-select-sm" style="width: 90px" [ngModel]="tamanhoPagina"
        (ngModelChange)="alterarTamanhoPagina($event)">
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select>

      <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
        [disabled]="totalPaginas === 0 || paginaAtual >= totalPaginas">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
